import React from "react";
import Button from "@material-ui/core/Button";

import ConfirmationButton from "../components/confirmation_button";
import DynamicSnackbar from "../components/dynamic_snackbar";
import LoadingBackdrop from "../components/loading_backdrop";
import issueStateUpdateRequest from "../components/panel_update_helper";

class DeveloperToolsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dynamicSnackbar: {
        open: false,
        severity: null,
        message: null,
        url: null,
      },
    };
  }

  render() {
    return (
      <div className="panel server-panel">
        <LoadingBackdrop open={this.state.loading} />
        <DynamicSnackbar
          open={this.state.dynamicSnackbar.open}
          severity={this.state.dynamicSnackbar.severity}
          message={this.state.dynamicSnackbar.message}
          url={this.state.dynamicSnackbar.url}
          handleClose={() => {
            this.setState({
              dynamicSnackbar: { ...this.state.dynamicSnackbar, open: false },
            });
          }}
        />
        <h1>Developer Tools</h1>

        <div className="panel-section">
          <Button
            variant="contained"
            color="primary"
            onClick={this.createTestAccount}
            title="Create Test Account"
          >
            Create Test Account
          </Button>

          <ConfirmationButton
            onClick={this.deleteAllSyncHashes}
            title="Delete ALL Sync Hashes"
            confirmationMessage="Confirming will delete ALL sync hashes?"
          >
            Delete ALL Sync Hashes
          </ConfirmationButton>
        </div>
      </div>
    );
  }

  async componentDidMount() {
    this.setState({ loading: false });
  }

  createTestAccount = async () => {
    await issueStateUpdateRequest(
      this,
      "/developer_tools_panel/create_test_account",
      null,
      "post"
    );
  };

  deleteAllSyncHashes = async () => {
    await issueStateUpdateRequest(
      this,
      "/developer_tools_panel/delete_all_sync_hashes",
      null,
      "post"
    );
  };
}

export default DeveloperToolsPanel;
